import SideBar from "./component/SideBar/SideBar";
import {useState} from "react";
import NavBar from "./component/NavBar/NavBar";
import {Route, Routes} from "react-router-dom";
import Pages from "./pages/pages/pages";
import AddPage from "./pages/pages/AddPage/AddPage";
import AddTest from "./pages/test/AddTest/AddPage";
import Test from "./pages/test/Test";
import Products from "./pages/Products/Products";
import AddProduct from "./pages/Products/AddProduct/AddProduct";
import UpdateProduct from "./pages/Products/UpdateProduct/UpdateProduct";
import ProductCategories from "./pages/ProductCategories/ProductCategories";
import AddProductCategory from "./pages/ProductCategories/AddProductCategory/AddProductCategory";
import UpdateProductCategory from "./pages/ProductCategories/UpdateProductCategory/UpdateProductCategory";
import AddBrand from "./pages/brands/AddBrand/AddBrand";
import Brands from "./pages/brands/Brands";
import UpdateBrand from "./pages/brands/UpdateBrand/UpdateBrand";
import UpdatePage from "./pages/pages/UpdatePage/UpdatePage";
import Managers from "./pages/Managers/Managers";
import AddManager from "./pages/Managers/AddManager/AddManager";
import UpdateManager from "./pages/Managers/UpdateManager/UpdateManager";
import Storagemen from "./pages/Storageman/Storagemen";
import AddStorageman from "./pages/Storageman/AddStorageman/AddStorageman";
import UpdateStorageman from "./pages/Storageman/UpdateStorageman/UpdateStorageman";
import Drivers from "./pages/Drivers/Drivers";
import AddDriver from "./pages/Drivers/AddDriver/AddDriver";
import UpdateDriver from "./pages/Drivers/UpdateDriver/UpdateDriver";
import Customers from "./pages/Customers/Customers";
import AddCustomer from "./pages/Customers/AddCustomer/AddCustomer";
import UpdateCustomer from "./pages/Customers/UpdateCustomer/UpdateCustomer";
import CreditCards from "./pages/CreditCards/CreditCards";
import AddCreditCard from "./pages/CreditCards/AddCreditCard/AddCreditCard";
import UpdateCreditCard from "./pages/CreditCards/UpdateCreditCard/UpdateCreditCard";
import DiscountCodes from "./pages/DiscountCode/DiscountCodes";
import AddDiscountCode from "./pages/DiscountCode/AddDiscountCode/AddDiscountCode";
import UpdateDiscountCode from "./pages/DiscountCode/UpdateDiscountCode/UpdateDiscountCode";
import AddTransaction from "./pages/Transactions/AddTransaction/AddTransaction";
import UpdateTransaction from "./pages/Transactions/UpdateTransaction/UpdateTransaction";
import Transactions from "./pages/Transactions/Transactions";
import Currencies from "./pages/Currencies/Currencies";
import AddCurrency from "./pages/Currencies/AddCurrency/AddCurrency";
import UpdateCurrency from "./pages/Currencies/UpdateCurrency/UpdateCurrency";
import ProductRequests from "./pages/Products/ProductRequests/ProductRequests";
import ProductComments from "./pages/ProductComments/ProductComments";
import Order from "./pages/Orders/Orders";
import AddOrder from "./pages/Orders/AddOrder/AddOrder";
import UpdateOrder from "./pages/Orders/UpdateOrder/UpdateOrder";
import Receipts from "./pages/Receipts/Receipts";
import Installments from "./pages/Installments/Installments";
import UpdateInstallment from "./pages/Installments/UpdateInstallment/UpdateInstallment";

const ManagerContent = () => {
    const [collapsed , setCollapsed] = useState(false);
    return (
        <div className="wrapper">
            <SideBar collapsed={collapsed}/>

            <div className="main">
                <NavBar setCollapsed={() => setCollapsed(!collapsed) } />

                <main className="content">
                    <Routes>
                        <Route path="pages" element={<Pages />} />
                        <Route path="pages/add" element={<AddPage />}/>
                        <Route path="pages/update/:id" element={<UpdatePage />}/>

                        <Route path="products" element={<Products />} />
                        <Route path="products/add" element={<AddProduct />}/>
                        <Route path="products/update/:id" element={<UpdateProduct />}/>
                        <Route path="products/requests" element={<ProductRequests />}/>

                        <Route path="comments" element={<ProductComments />}/>

                        <Route path="productCategories" element={<ProductCategories />} />
                        <Route path="productCategories/add" element={<AddProductCategory />} />
                        <Route path="productCategories/update/:id" element={<UpdateProductCategory />} />

                        <Route path="brands" element={<Brands />} />
                        <Route path="brands/add" element={<AddBrand />} />
                        <Route path="brands/update/:id" element={<UpdateBrand />} />

                        <Route path="managers" element={<Managers />} />
                        <Route path="managers/add" element={<AddManager />} />
                        <Route path="managers/update/:id" element={<UpdateManager />} />

                        <Route path="storagemen" element={<Storagemen />} />
                        <Route path="storagemen/add" element={<AddStorageman />} />
                        <Route path="storagemen/update/:id" element={<UpdateStorageman />} />

                        <Route path="drivers" element={<Drivers />} />
                        <Route path="drivers/add" element={<AddDriver />} />
                        <Route path="drivers/update/:id" element={<UpdateDriver />} />

                        <Route path="customers" element={<Customers />} />
                        <Route path="customers/add" element={<AddCustomer />} />
                        <Route path="customers/update/:id" element={<UpdateCustomer />} />

                        <Route path="credit-cards" element={<CreditCards />} />
                        <Route path="credit-cards/add" element={<AddCreditCard />} />
                        <Route path="credit-cards/update/:id" element={<UpdateCreditCard />} />

                        <Route path="discount-codes" element={<DiscountCodes />} />
                        <Route path="discount-codes/add" element={<AddDiscountCode />} />
                        <Route path="discount-codes/update/:id" element={<UpdateDiscountCode />} />

                        <Route path="transactions" element={<Transactions />} />
                        <Route path="receipts" element={<Receipts />} />
                        <Route path="installments" element={<Installments />} />
                        <Route path="installments/update/:id" element={<UpdateInstallment />} />
                        <Route path="transactions/add" element={<AddTransaction />} />
                        <Route path="transactions/update/:id" element={<UpdateTransaction />} />


                        <Route path="currencies" element={<Currencies />} />
                        <Route path="currencies/add" element={<AddCurrency />} />
                        <Route path="currencies/update/:id" element={<UpdateCurrency />} />

                        <Route path="orders" element={<Order />} />
                        <Route path="orders/add" element={<AddOrder />} />
                        <Route path="orders/update/:id" element={<UpdateOrder />} />


                        <Route path="test" element={<Test />} />
                        <Route path="test/add" element={<AddTest />}/>
                        
                        <Route path="about" element={<h1>ABOUT</h1>} />
                    </Routes>

                </main>

                <footer className="footer">
                    <div className="container-fluid">
                        <div className="row text-muted">
                            <div className="col-6 text-start">
                                <p className="mb-0">
                                    <a className="text-muted" href="https://adminkit.io/"
                                       target="_blank"><strong>AdminKit</strong></a> - <a className="text-muted"
                                                                                          href="https://adminkit.io/"
                                                                                          target="_blank"><strong>Bootstrap
                                    Admin Template</strong></a>                                &copy;
                                </p>
                            </div>
                            <div className="col-6 text-end">
                                <ul className="list-inline">
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/"
                                           target="_blank">Support</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/" target="_blank">Help
                                            Center</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/"
                                           target="_blank">Privacy</a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="text-muted" href="https://adminkit.io/" target="_blank">Terms</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>

        </div>
    );
}

export default ManagerContent;